import { FilterKey } from '@app/hooks/use-data-table-query-state';

/**
 * Facet filters for the uncategorised (Uncertain / Other) tabs. The shared
 * Excluded items toolbar writes the selected values to the URL under the
 * `column` keys; each tab maps them to the endpoint's `apiKey` query params
 * (UncategorisedPurchasedGoodFilter on the backend) when fetching its list.
 */
export const uncategorisedFilters = [
  { column: 'site', apiKey: 'sites' },
  { column: 'period', apiKey: 'time_periods' },
  { column: 'supplier', apiKey: 'suppliers' },
  { column: 'activitiesImport', apiKey: 'activity_imports' },
  { column: 'tag', apiKey: 'tags' },
] as const;

/** URL filter keys read from query state, alongside `search`. */
export const uncategorisedFilterColumns = uncategorisedFilters.map(
  (filter) => filter.column
) as FilterKey[];
